module.exports = __webpack_public_path__ + "assets/img/course_worksheet_head3.01e5fe0d.png";